import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useQueryFilter from 'hooks/useQueryFilter';
import useMatchMedia from 'hooks/useMatchMedia';
import ResolveMultiSelect from 'components/ResolveMultiSelect';
import utils, { getArrayLength } from 'utils';
import { Option } from 'models/Global';
import { FIRST_PAGE } from 'data/global';

type SuggestedActionsDealFilterProps = {
  className?: string;
  options: Option[];
  filterKey: string;
  pageKey?: string;
};

const SuggestedActionsDealFilter: React.FC<SuggestedActionsDealFilterProps> = (
  props,
) => {
  const { className, options, filterKey, pageKey } = props;

  const { t } = useTranslation();

  const isPhablet = useMatchMedia('isPhablet');

  const { params, onFiltersApply, applyQueryFilter } = useQueryFilter();

  const selectedDeals = useMemo(
    () => utils.mapParamsToArray(params[filterKey]),
    [params, filterKey],
  );

  const handleChange = useCallback(
    (values: string[]) => {
      onFiltersApply(filterKey, values);
      if (pageKey) applyQueryFilter(pageKey, FIRST_PAGE);
    },
    [filterKey, pageKey, onFiltersApply, applyQueryFilter],
  );

  const classes = classNames('suggested-actions-deal-filter', className);

  if (getArrayLength(options) < 2) return null;

  return (
    <ResolveMultiSelect
      className={classes}
      hasCheckbox
      renderAsPortal={!isPhablet}
      value={selectedDeals}
      options={options}
      pillText={t('deals')}
      onChange={handleChange}
    />
  );
};

export default SuggestedActionsDealFilter;
